
import { LockIcon, UnlockIcon, ChevronDownIcon } from 'vue-feather-icons'
import CropMixin from '~/mixins/cropper'
import { setInputFilter } from '~/fc/Helpers/DOMHelper'

export default {
    name: 'CustomDimension',
    components: {
        ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip'),
        LockIcon,
        UnlockIcon,
        ChevronDownIcon
    },
    mixins: [CropMixin],
    props: ['value', 'field', 'selection'],
    data: () => ({
        options: {},
        defaultUnit: '',
        units: false,
        maxDimension: {}
    }),
    computed: {
        extra() {
            return this.$store.state.extra
        },
        fullLayout() {
            return this.field.customVariables && this.field.customVariables.layout === 'full'
        },
        first() {
            return parseFloat(this.value
                ? this.value.includes('|')
                    ? this.value.split('|')[0].split(',')[0]
                    : this.value.split(',')[0]
                : 0)
        },
        second() {
            return parseFloat(this.value
                ? this.value.includes('|')
                    ? this.value.split('|')[0].split(',')[1]
                    : this.value.split(',')[1]
                : 0)
        },
        dataUnit() {
            const value = this.value && this.value.includes('|')
                ? this.value.split('|')[1]
                : this.units
                    ? this.defaultUnit
                    : false

            if (value && this.field.customVariables[`max_${value}`] !== undefined) {
                const maxValue = this.field.customVariables[`max_${value}`]
                this.maxDimension = { height: maxValue, width: maxValue }
            }

            return value
        },
        dimension() {
            return `${this.first},${this.second}|${this.dataUnit}`
        },
        advancedOptionListResponsiveView() { return this.$store.state.store.advancedOptionListResponsiveView },
        locked() { return this.aspectRatioComputed !== '6029fe07e2679d0023d12181' },
        files() { return this.$store.state.list },
        isValidDimension() {
            return this.$store.state.isValidDimension;
        },
        info() { return this.$store.state.info; }
    },
    watch: {
        extra(newValue) {
            if (!newValue) return;
            this.maxDimension = {
                height: newValue.video_height,
                width: newValue.video_width
            }
        },
        first(newValue, oldValue) {
            if (!this.isValidMinDimension(newValue)) {
                this.$store.commit('setIsValidVideoDimension', false)
                return
            }

            if (!this.isValidMaxDimension(newValue, 'width')) {
                this.$store.commit('setIsValidVideoDimension', false)
                return
            }

            if (!this.isValidMaxDimension(this.second, 'height')) {
                this.$store.commit('setIsValidVideoDimension', false)
                const heightEl = document.getElementById("CustomDimensionHeight")
                const errorMessage = this.checkErrorOnElement(heightEl, 'height')
                this.displayOrRemoveErrorFromElement(heightEl, errorMessage);
                return
            }

            // width and height are valid
            if (this.isValidMinDimension(this.second)) {
                this.$store.commit('setIsValidVideoDimension', true)
            }
        },
        second(newValue, oldValue) {
            if (!this.isValidMinDimension(newValue)) {
                this.$store.commit('setIsValidVideoDimension', false)
                return
            }

            if (!this.isValidMaxDimension(newValue, 'height')) {
                this.$store.commit('setIsValidVideoDimension', false)
                return
            }

            if (!this.isValidMaxDimension(this.first, 'width')) {
                this.$store.commit('setIsValidVideoDimension', false)
                const widthEl = document.getElementById("CustomDimensionWidth")
                const errorMessage = this.checkErrorOnElement(widthEl, 'width')
                this.displayOrRemoveErrorFromElement(widthEl, errorMessage);
                return
            }

            // width and height are valid
            if (this.isValidMinDimension(this.first)) {
                this.$store.commit('setIsValidVideoDimension', true)
            }
        },
        dataUnit(newValue, oldValue) {
            const widthEl = document.getElementById("CustomDimensionWidth")
            let errorMessage = this.checkErrorOnElement(widthEl, 'width')
            if (errorMessage) {
                this.$store.commit('setIsValidVideoDimension', false)
                this.displayOrRemoveErrorFromElement(widthEl, errorMessage);
                return;
            } else {
                this.displayOrRemoveErrorFromElement(widthEl, errorMessage);
            }

            const heightEl = document.getElementById("CustomDimensionHeight")
            errorMessage = this.checkErrorOnElement(heightEl, 'height')
            this.displayOrRemoveErrorFromElement(heightEl, errorMessage);

            if (errorMessage) {
                this.$store.commit('setIsValidVideoDimension', false)
            } else {
                this.$store.commit('setIsValidVideoDimension', true)
            }
        },
        isValidDimension(newValue, oldValue) {
            if (newValue) {
                const widthEl = document.getElementById('CustomDimensionWidth')
                const heightEl = document.getElementById('CustomDimensionHeight')
                if (widthEl) {
                    widthEl.classList.remove('red-border')
                }
                if (heightEl) {
                    heightEl.classList.remove('red-border')
                }
            }
        }
    },
    mounted() {
        setInputFilter(document.getElementById('CustomDimensionWidth'), null, null, this.field.input_type, false, function(value) {
            return /^-?\d*[.,]?\d*$/.test(value); }, () => {}, () => {})
        setInputFilter(document.getElementById('CustomDimensionHeight'), null, null, this.field.input_type, false, function(value) {
            return /^-?\d*[.,]?\d*$/.test(value); }, () => {}, () => {})
        if (this.field.units && this.field.units !== '') {
            const values = this.field.units.split(',')
            if (values.length > 1) {
                this.units = true
                const options = {}
                values.forEach((v) => {
                    options[v.split(':')[0]] = v.split(':')[1]
                })
                this.defaultUnit = this.dataUnit || Object.keys(options)[0]
                this.options = options
                this.$emit(
                    'input',
                    this.first + ',' + this.second + (this.units ? '|' + this.defaultUnit : '')
                )
            }
        }
        setTimeout(() => {
            if (document.getElementById('VideoPlayer_html5_api')) {
                const { videoHeight, videoWidth } = document.getElementById('VideoPlayer_html5_api')
                this.maxDimension = { height: videoHeight, width: videoWidth }
            }
        }, 500)
    },
    beforeDestroy() {
        // since user can not apply a wrong value, and when this component is destroyed,
        // this advanced option's value will be the default or previous valid value.
        // so we are clearing the state.
        this.$store.commit('setIsValidVideoDimension', true)
    },
    methods: {
        displayOrRemoveErrorFromElement(element, message) {
            if (!message) {
                element.classList.remove("red-border");
                element.classList.remove("input-error");
                element.setCustomValidity(' ');
            } else {
                element.classList.add("red-border");
                element.classList.add("input-error");
                element.setCustomValidity(message);
                element.reportValidity();
            }
        },
        checkErrorOnElement(element, dimension) {
            let message = ''
            const unit = this.dataUnit || 'px'
            if (!this.isValidMinDimension(Number(element.value))) {
                message = this.$t('min_dimension_warning').replace('X', this.$t(dimension)).replace('N', '10').replace('UNIT', unit)
            } else if (this.maxDimension && !this.isValidMaxDimension(Number(element.value), dimension)) {
                message = this.$t('max_dimension_warning').replace('X', this.$t(dimension)).replace('N', this.maxDimension[dimension]).replace('UNIT', unit)
            }

            return message;
        },
        handleInvalidDimension(e, dimension) {
            e.preventDefault();
            const element = e.target;
            const errorMessage = this.checkErrorOnElement(element, dimension);
            this.displayOrRemoveErrorFromElement(element, errorMessage);
        },
        isValidMinDimension(value) {
            // 0 is an accepted value for general video conversion
            if (this.info?.slug !== 'crop-video' && value === 0) return true
            return value >= 10
        },
        isValidMaxDimension(value, dimension) {
            if (this.maxDimension && this.maxDimension[dimension]) {
                return value <= this.maxDimension[dimension]
            }
            return true
        },
        changeFirst(e) {
            e.target.value = parseFloat(e.target.value || 0)        
            // lets set the variable for customdimentionfirst focus
            this.$store.commit('advancedSetting/setCustomDimensionActiveInput', 'width')
            this.handleInvalidDimension(e, 'width');
            this.$emit('input', e.target.value + ',' + this.second + (this.units ? '|' + this.dataUnit : ''))  
        },
        changeSecond(e) {
            e.target.value = parseFloat(e.target.value || 0)
            // lets set the variable for customdimentionfirst focus
            this.$store.commit('advancedSetting/setCustomDimensionActiveInput', 'height')
            this.handleInvalidDimension(e, 'height');
            this.$emit('input', this.first + ',' + e.target.value + (this.units ? '|' + this.dataUnit : ''))
        },
        onSelect(e) {
            this.$emit('input', this.first + ',' + this.second + '|' + e.target.value)
        },
        handleLock() {
            const uid = 'root'
            const freeform = '6029fe07e2679d0023d12181'
            const custom = '62493c578df052001366539c'
            const field = {
                id: '60282925b61d2f0023b20a2f',
                name: 'crop_aspect_ratio'
            }
            this.commitCropChanges({ uid, field, value: this.locked ? freeform : custom })
        }
    }
}
